export const errMsgMappings = {
    shootName: [
        {
            be:
                "Shoot name contains disallowed characters. Please try a different name.",
            fe: "Shoot name not saved because it contains invalid characters."
        }
    ]
};
